export const ANALYTIC_ID = "UA-185659622-1";

// --- Stage --- //
// export const STRIPE_ID = {
//   premium_monthly: "price_1LUoPRAlY9R4Wa1pA1bRGcqI",
//   premium_quarterly: "price_1LUoPRAlY9R4Wa1pnedEpbFN",
//   premium_yearly: "price_1LUoPRAlY9R4Wa1pQVlcuvQt",
//   pro_monthly: "price_1LUoQqAlY9R4Wa1pCHtuCRyL",
//   pro_quarterly: "price_1LUoQqAlY9R4Wa1pHXgn0WtD",
//   pro_yearly: "price_1LUoQqAlY9R4Wa1pLQpfu5ht",
//   master_monthly: "price_1M0KiIAlY9R4Wa1plVLG6Jsc",
//   master_quarterly: "price_1M0KiIAlY9R4Wa1pG7omlB0s",
//   master_yearly: "price_1M0KiIAlY9R4Wa1pBgotPSuf",
// };
// export const STRIPE_PUBLIC =
//   "pk_test_51HWbXkAlY9R4Wa1pNNTATqAnlvpeeXyJ9I85E1B0QYUsIUPs84z84uQM9pVzm7hesVq2w6KQTmxu3tIXoEf0adRl0043MvXJnW";
// export const PAYPAL_CLIENT_ID =
//   "AdyEXlxP7oRawx9Np29KNveKNda4sUXi1knI1lGJjQA-Ko-Awlgdsxwg_MokjKMKOAwwDbgaw6oKinRb";
// export const PAYPAL_ID = {
//   premium_monthly: "P-9CX32107U7680961CMCXR63I",
//   premium_quarterly: "P-38W09204WV216413JMMWT4EY",
//   premium_yearly: "P-76B0268383535172GMCXR7HQ",
//   pro_monthly: "P-74U918610A5719342MCXR7TY",
//   pro_quarterly: "P-9Y575476XH237445JMMWT4QA",
//   pro_yearly: "P-52E196148S466304WMCXR74Y",
//   master_monthly: "P-74U918610A5719342MCXR7TY",
//   master_quarterly: "P-9Y575476XH237445JMMWT4QA",
//   master_yearly: "P-52E196148S466304WMCXR74Y",
// };
// export const host = "https://web-stage.cryptohero.ai/api";
// export const ws = "wss://app-stage.cryptohero.ai";
// export const klineUrl = "https://web-stage.cryptohero.ai/api/klines";




//--- Live --- //
export const STRIPE_ID = {
  premium_monthly: "price_1QZQy0AlY9R4Wa1pk0kYOn4x",
  premium_quarterly: "price_1QZQygAlY9R4Wa1pYO9IOGB6",
  premium_yearly: "price_1QZQzHAlY9R4Wa1p4jWlEpwu",
  pro_monthly: "price_1QZQzoAlY9R4Wa1phXIdWvdn",
  pro_quarterly: "price_1QZR0FAlY9R4Wa1pX0knoAcI",
  pro_yearly: "price_1QZR0lAlY9R4Wa1p62jBOzGh",
  master_monthly: "price_1M0KfdAlY9R4Wa1pgdxe87LR",
  master_quarterly: "price_1M0KfdAlY9R4Wa1pEzwvyqJK",
  master_yearly: "price_1M0KfdAlY9R4Wa1psjl23mun",
};

export const STRIPE_PUBLIC =
  "pk_live_51HWbXkAlY9R4Wa1pbPPwS6UJRtGLjM2s4EIN3N8ZLfZG4e5N7hDKbReLX3FRMmV5VjpoegfZJ3635q7GezMqX2ca00AygFxyo1";
export const PAYPAL_CLIENT_ID =
  "AXiiuwDKX_IHOPCeiHfTMvvrMl56Q3W9M2UHYWY6cuA0ycOe21qknO-UToK1LZmSFjEIWgXQ56Xjrwfk";

export const PAYPAL_ID = {
  premium_monthly: "P-7L382215Y04712103M5VE44A",
  premium_quarterly: "P-18375120668383417M5VE2JY",
  premium_yearly: "P-52P84092VF120301XM5VE5MY",
  pro_monthly: "P-0JE93128GX393294KM5VE6KY",
  pro_quarterly: "P-02A189315E071354XM5VE4CY",
  pro_yearly: "P-0TC15994NG156444WM5VE55A",
  master_monthly: "P-9TP03342XK691740CMNSNADI",
  master_quarterly: "P-4FB345541S678824LMNSNAYA",
  master_yearly: "P-33N08304UW649823EMNSNBFY",
};
export const host = "https://alb-api.cryptohero.ai/api";

export const ws = "wss://app-stage.cryptohero.ai";
export const klineUrl = "https://alb-api.cryptohero.ai/api/klines";


// --- Local --- //
// export const STRIPE_ID = {
//   premium_monthly: "price_1LUoLvAlY9R4Wa1pW57ogfAf",
//   premium_quarterly: "price_1LUoLvAlY9R4Wa1pvUCJUKq8",
//   premium_yearly: "price_1LUoLvAlY9R4Wa1p63xnrDzq",
//   pro_monthly: "price_1LUoNVAlY9R4Wa1pasDLUkbq",
//   pro_quarterly: "price_1LUoNVAlY9R4Wa1prrRYzPlY",
//   pro_yearly: "price_1LUoNVAlY9R4Wa1poNKXsdh0",
//   lite_monthly: "price_1LUoKeAlY9R4Wa1pKWnFH3Pt",
//   lite_quarterly: "price_1LUoKeAlY9R4Wa1pjHhKUvSz",
//   lite_yearly: "price_1LUoKeAlY9R4Wa1pzJ3t9LGo",
// };
// export const STRIPE_PUBLIC =
//   "pk_test_51HWbXkAlY9R4Wa1pNNTATqAnlvpeeXyJ9I85E1B0QYUsIUPs84z84uQM9pVzm7hesVq2w6KQTmxu3tIXoEf0adRl0043MvXJnW";
// export const PAYPAL_CLIENT_ID =
//   "AQ58lfbo34MvYYhVOxBiLjziBQvAnOO5bN4JUdj9nxjiOKGkDn_03xqacAC8DWEj2vxCUh_8RSm6X_Pp";
// export const PAYPAL_ID = {
//   lite_monthly: "P-72J29231CS4680612ML7BARA",
//   lite_quarterly: "P-5M205282KR506954EML7BBEI",
//   lite_yearly: "P-4GF757066W302213UMMHP3GI",
//   premium_monthly: "P-76B0268383535172GMCXR7HQ",
//   premium_quarterly: "P-76B0268383535172GMCXR7HQ",
//   premium_yearly: "P-76B0268383535172GMCXR7HQ",
//   pro_monthly: "P-74U918610A5719342MCXR7TY",
//   pro_quarterly: "P-72J29231CS4680612ML7BARA",
//   pro_yearly: "P-52E196148S466304WMCXR74Y",
// };
// export const host = "https://cryptohero-api.test/api";
// export const ws = "wss://api-stage.stockhero.ai";
// export const klineUrl = "https://cryptohero-api.test/api/klines";
